var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-btn",
    {
      staticClass: "no-margin no-padding",
      attrs: { flat: "", small: "", color: "info", icon: "more_vert" }
    },
    [
      _c(
        "q-popover",
        [
          _c(
            "q-list",
            { attrs: { link: "" } },
            [
              _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" }
                  ],
                  attrs: { to: _vm.clientRoute }
                },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-icon", {
                        attrs: { name: "open_in_new", color: "info" }
                      })
                    ],
                    1
                  ),
                  _c("q-item-main", [
                    _vm._v("\n          Edit Record\n        ")
                  ])
                ],
                1
              ),
              _c(
                "q-item",
                {
                  directives: [
                    { name: "close-overlay", rawName: "v-close-overlay" }
                  ],
                  attrs: { link: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.handleQuickEdit.apply(null, arguments)
                    }
                  }
                },
                [
                  _c(
                    "q-item-side",
                    [
                      _c("q-icon", {
                        attrs: { name: "open_in_new", color: "info" }
                      })
                    ],
                    1
                  ),
                  _c("q-item-main", [
                    _vm._v("\n          Quick Edit Record\n        ")
                  ])
                ],
                1
              ),
              _vm.$route.path === "/event/list"
                ? [
                    _c(
                      "div",
                      [
                        _c(
                          "q-item",
                          {
                            directives: [
                              {
                                name: "close-overlay",
                                rawName: "v-close-overlay"
                              }
                            ],
                            attrs: { to: _vm.editRoutes("edit", "/attendees") }
                          },
                          [
                            _c(
                              "q-item-side",
                              [
                                _c("q-icon", {
                                  attrs: {
                                    name: "supervisor account",
                                    color: "info"
                                  }
                                })
                              ],
                              1
                            ),
                            _c("q-item-main", [
                              _vm._v("\n              Attendees\n            ")
                            ])
                          ],
                          1
                        ),
                        _vm.row.eventType &&
                        _vm.row.eventType.id &&
                        _vm.row.eventType.id === 2
                          ? _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  }
                                ],
                                attrs: { to: _vm.editRoutes("edit", "/groups") }
                              },
                              [
                                _c(
                                  "q-item-side",
                                  [
                                    _c("q-icon", {
                                      attrs: { name: "group", color: "info" }
                                    })
                                  ],
                                  1
                                ),
                                _c("q-item-main", [
                                  _vm._v(
                                    "\n              Groups/Teams\n            "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.row && _vm.row.id
                          ? _c(
                              "q-item",
                              {
                                directives: [
                                  {
                                    name: "close-overlay",
                                    rawName: "v-close-overlay"
                                  }
                                ],
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.duplicate(_vm.row.id)
                                  }
                                }
                              },
                              [
                                _c(
                                  "q-item-side",
                                  [
                                    _c("q-icon", {
                                      attrs: {
                                        name: "control_point_duplicate",
                                        color: "info"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("q-item-main", [
                                  _vm._v(
                                    "\n              Duplicate\n            "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.$route.path === "/admin/hr/employees/list"
                ? [
                    _c(
                      "q-item",
                      {
                        directives: [
                          { name: "close-overlay", rawName: "v-close-overlay" }
                        ],
                        attrs: {
                          to: _vm.editRoutes("hr/timecards", "", "/admin")
                        }
                      },
                      [
                        _c(
                          "q-item-side",
                          [
                            _c("q-icon", {
                              attrs: { name: "access_time", color: "info" }
                            })
                          ],
                          1
                        ),
                        _c("q-item-main", [
                          _vm._v("\n            Timecard\n          ")
                        ])
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.$route.path === "/admin/schools/reports/list"
                ? [
                    _c(
                      "q-item",
                      {
                        directives: [
                          { name: "close-overlay", rawName: "v-close-overlay" }
                        ],
                        nativeOn: {
                          click: function($event) {
                            return _vm.downloadFile("pdf/manager-visit-reports")
                          }
                        }
                      },
                      [
                        _c(
                          "q-item-side",
                          [
                            _c("q-icon", {
                              attrs: {
                                name: "assignment_returned",
                                color: "info"
                              }
                            })
                          ],
                          1
                        ),
                        _c("q-item-main", [
                          _vm._v("\n            Download PDF\n          ")
                        ])
                      ],
                      1
                    )
                  ]
                : _vm._e(),
              _vm.user
                ? _c(
                    "q-item",
                    {
                      directives: [
                        { name: "close-overlay", rawName: "v-close-overlay" }
                      ],
                      nativeOn: {
                        click: function($event) {
                          return _vm.handleLogin.apply(null, arguments)
                        }
                      }
                    },
                    [
                      _c(
                        "q-item-side",
                        [
                          _c("q-icon", {
                            attrs: { name: "account_circle", color: "info" }
                          })
                        ],
                        1
                      ),
                      _c("q-item-main", [
                        _vm._v("\n          Login As User\n        ")
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }